<template>
  <span v-if="params.data.invoice_for !== 'SELF'">
    <vs-tooltip
      color="primary"
      text="Share the invoice"
      v-if="params.data.is_shared_to_client === 0"
    >
      <span
        class="material-icons share-rotate cursor-pointer"
        @click="params.colDef.CellRendererParams.shareManualInvoiceConfirm(params.data)"
      >
        reply
      </span>
    </vs-tooltip>
    <vs-tooltip 
      v-else 
      color="#28c870" 
      text="Invoice is shared"
    >
      <span
        class="material-icons-outlined pay_shared"
        style="color: #28c870; opacity: 0.4"
      >
        task_alt
      </span>
    </vs-tooltip>
  </span>
</template>

<script>
export default {
  name: 'ShareCell'
}
</script>